import React, { useState } from "react";
import "./QuoteRequestForm.css";

const QuoteRequestForm = () => {
  const [result, setResult] = useState("");
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    const formData = new FormData(event.target);
    formData.append("access_key", "a5e9d21c-efff-4bfb-ab9f-440f49620bea");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setResult("Thank you! We’ll contact you soon.");
        event.target.reset();
      } else {
        console.error("Submission error:", data);
        setResult("Something went wrong. Please try again later or contact us directly.");
      }
    } catch (error) {
      console.error("Network error:", error);
      setResult("Error connecting. Please try again or reach us at info@spatialct.co.");
    }
  };

  return (
    <section className="quote-section">
      <div className="quote-container">
        <div className="quote-header">
          <p className="quote-subtitle">LET'S TALK</p>
          <h2 className="quote-title">Request for Demo</h2>
        </div>
        <form className="quote-form" onSubmit={onSubmit}>
          <div className="form-row">
            <input type="text" name="name" placeholder="Name" className="form-input" required />
            <input type="email" name="email" placeholder="E-Mail" className="form-input" required />
          </div>
          <div className="form-row">
            <input type="tel" name="phone" placeholder="Phone Number" className="form-input" required />
          </div>
          <textarea
            name="message"
            placeholder="Your Message Here"
            className="form-textarea"
            rows="4"
            required
          ></textarea>
          <button type="submit" className="submit-btn">
            SUBMIT NOW
          </button>
          <span className="sending">{result}</span>
        </form>
      </div>
    </section>
  );
};

export default QuoteRequestForm;
